import {
    VARIANT_DEFAULT,
    DEFAULT_TEMPLATE,
    DEFAULT_ICON_FOLDER_VERSION,
    DEFAULT_MEGANAV_API_VERSION,
    DEFAULT_CDN_BASEURL,
} from "../../config/constants"

export const SET_SETTINGS = "SET_SETTINGS"
export const SET_TABBED_NAVIGATION_ENABLED = "SET_TABBED_NAVIGATION_ENABLED"

/**
 * add as needed new feature settings
 */
export class SettingsModel {
    "userConsentManagement.enabled" = false
    bloomreachCookieFullDomain = false
    enableMinibagNotification = true
    enableRecentSearches = true
    iconsVersionPath = DEFAULT_ICON_FOLDER_VERSION
    meganavApiVersion = DEFAULT_MEGANAV_API_VERSION
    rememberSelectedDepartment = true
    saleName = ""
    showCheckoutButton = true
    showCloseButtonMobileSearch = true
    showStaticHeaderBanner = false
    template = DEFAULT_TEMPLATE
    useBloomreachSegmentCookie = false
    variant = VARIANT_DEFAULT
    developmentToolsEnabled = false
    showTestTools = false
    updatedmasid = true
    tabbedNavigationEnabled = false
    cdnBaseUrl = DEFAULT_CDN_BASEURL
    bloomReachConfig = {
        apiUrl: "",
        accountId: "",
        domainKey: "",
        authKey: "",
        territory: "",
    }

    excludeMonetateOnPageTypesIsEnabled = false
    personalisationEnabled = true
    enableContentBanner = false
    contentBannerCmsPath = ""
    bloomReachSdkEnabled = false
    branchIOEnabled = false
    seoClientSidePixelEnabled = false
    showSignoutButton = false
    showMyAccountIcon = true
    tpLitePath = ""
    personalisationDataRetrievalEnabled = false
    personalisationDataRetrievalAPIVersion = "v2"
    simpleSearchEnabled: boolean
    enrichedSearchEnabled: boolean
    recentSearchesMaxItems: {simple: number; enriched: number}
    autocompleteMaxItems: {xs: number; sm: number; md: number; lg: number; xl: number; xxl?: number}
    enrichedMaxItems: {xs: number; sm: number; md: number; lg: number; xl: number; xxl?: number}
    autocompleteEnabled: boolean
    seoClientSidePixelUseEffectEnabled = false
    themeName = ""
    threeFourImageryEnabled = false
    enrichedSearchImagePath = ""
    miniBagImagePath = ""
    backToSiteBannerEnabled = false
    backToSiteBannerConfiguration = {
        showBanner: false,
        originRealm: "",
    }

    backToNextBannerShowAlways = false

    coreMediaAuthTokenName = ""
    coreMediaAuthTokenValue = ""
    secureHeaderEnabled = false
    bloomreachSdkApiConfigs: any
    bloomreachSdkCustomConfigs: any
    bloomreachSdkCustomConfigsReject: any
    preconnectUrlsConfiguration: {
        preconnectUrls: string[]
    }

    countrySelectorRedirectEnabled = false
    coreMediaRelativeUrl: ""
    messageBannerPath: ""
    meganavCircularIconsEnabled = true
    xxlBreakpointEnabled = false
    isCountrySelectorInGlobalAppBar = false
    isTpSuperLite = false
    isAutoSuggestHighlightEnabled = false
    personalisationSessionDataExpirationTime = 1440
    xxlBreakpointMaxWidth = 1840
    textDataName = ""
}

const initialState = new SettingsModel()

interface SetSettings {
    type: typeof SET_SETTINGS
    value: SettingsModel
}

interface SetTabbedNavigationEnabled {
    type: typeof SET_TABBED_NAVIGATION_ENABLED
    value: boolean
}

type SettingsActions = SetSettings

export const setSettings = (value: SettingsModel): SetSettings => {
    return {
        type: SET_SETTINGS,
        value,
    }
}

export const updateSettings = (store, settings: SettingsModel) => {
    store.dispatch(setSettings(settings))
}

export const setTabbedNavigationEnabled = (value: boolean): SetTabbedNavigationEnabled => {
    return {
        type: SET_TABBED_NAVIGATION_ENABLED,
        value,
    }
}

export const settingsReducer = (
    state: SettingsModel = initialState,
    action: SettingsActions | SetTabbedNavigationEnabled,
): SettingsModel => {
    switch (action.type) {
        case SET_SETTINGS:
            // If a setting is missing, then the default value will persist
            return {
                ...state,
                ...action.value,
            }
        case SET_TABBED_NAVIGATION_ENABLED:
            return {
                ...state,
                tabbedNavigationEnabled: action.value,
            }
        default:
            return state
    }
}
